<div #wrapper class="wrapper" (click)="onShowDetails()">

  <div class="image-wrapper">

    <div class="image-placeholder {{(isActive$ | async) ? 'active' : ''}}">
      <tun-image-on-screen-loader class="image" [src]="imageUrl"></tun-image-on-screen-loader>


      @if (playButtonShowStragegy != PlayButtonShowStrategy.NEVER && (mouseOver || (forceShowTogglePlayButton$ | async))) {
        <div class="playButtonContainer {{(playButtonShowStragegy != PlayButtonShowStrategy.NEVER) ? 'showOnHover' : '' }} {{(forceShowTogglePlayButton$ | async) ? 'forceShow': ''}}">
          <tun-play-music-selection-button
            class="play-button"
            [itemToStart]="startableItem"
            [forcePlayable]="true"
            (itemIsStarting)="onItemIsStarting()"
            >
          </tun-play-music-selection-button>
        </div>
      }

    </div>

  </div>


  <div class="titleContainer">
    @if (showPlayAnimation$ | async) {
      <tun-music-play-animation
        class="playAnimationContainer"
        [playing]="animatePlayAnimation$ | async"
        [musicPlayAnimationColors]="playAnimationColors"
        >
      </tun-music-play-animation>
    }
    @if (imageHolder != null) {
      <tun-scrollable-text class="title" [text]="imageHolder.name"></tun-scrollable-text>
    }
  </div>


  @if (recommendationsAmount > 0) {
    <div class="badgeContainer">
      <div class="badge">
        {{recommendationsAmount}}
      </div>
    </div>
  }


</div>


